<template>
    <div id="app">
        <keep-alive :include="routerIncludes">
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
    import apiService from './repository/api/ApiService'
    import bluetoothRepository from './repository/bluetooth/BluetoothRepository'
    import userRepository from './repository/store/UserRepository'
    import storeRepository from './repository/store/StoreRepository'
    import "./assets/css/common.scss"
    import log from "./repository/log/log"

    export default {
        name      : 'App',
        components: {},
        data() {
            return {
                imageUrl      : '',
                routerIncludes: ['Home', 'Message', 'Mine', 'MineFAQ', "IngredientInfo"]
            }
        },
        mounted() {
            const _this = this;
            apiService.splashPage({
                success(data) {
                    _this.$router.replace({name: 'Splash', params: {imageUrl: data.startupPage}})
                },
                fail() {

                }
            })
        },
        watch     : {
            $route(to, from) {
                log(`to = ${to.name} , from = ${from.name}`)
                if (to.name === 'Login') {
                    this.routerIncludes = []
                    this.routerIncludes = ['Home', 'Message', 'Mine', 'MineFAQ', "IngredientInfo"]
                    return
                }

                if ((to.name === 'IngredientInfo' && from.name === "Home")){
                    if (!this.routerIncludes.includes("IngredientInfo")) {
                        this.routerIncludes.push("IngredientInfo")
                    }
                }

                if (to.name === "Home" && from.name === "IngredientInfo") {
                    if (this.routerIncludes.includes("IngredientInfo")) {
                        let index = this.routerIncludes.indexOf("IngredientInfo");
                        if (index > -1) {
                            this.routerIncludes.splice(index, 1);
                        }
                    }
                }

                if (to.name === 'Home' || to.name === 'IngredientInfo') {
                    if (!bluetoothRepository.isConnected()) {
                        if (userRepository.isLogin()) {
                            const user = storeRepository.getUser()
                            if (user) {
                                if (user.isReply) {
                                    this.$router.replace({name: 'Pair'})
                                } else {
                                    this.$router.replace({name: 'Questions'})
                                }
                            } else {
                                storeRepository.clearAll()
                                this.$router.replace({name: 'Login'})
                            }
                        } else {
                            this.$router.replace({name: 'Login'})
                        }
                    }
                }
            }
        }
    }
</script>

<style lang="scss">

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        padding: 0;
        margin: 0;
        background: #111111;
        width: 100%;
        height: 100%;
    }
</style>
